define('common/specifications/validEmailAddressSpecification',[
    'common/promises/promiseFactory',
    'persistence/webSocket/webSocketApp'
], function() {
    return function() {
        const self = this;

        const PromiseFactoryConstructor = require('common/promises/promiseFactory');
        const _promiseFactory = new PromiseFactoryConstructor();

        const WebSocketAppConstructor = require('persistence/webSocket/webSocketApp');
        const _webSocketApp = new WebSocketAppConstructor();
        _webSocketApp.init("validation");

        const EMAIL_ADDRESS_REGULAR_EXPRESSION = new RegExp(/^[\w\-.+]+@[\w\-.]+\.[\w\-.]+$/i);

        self.isSatisfiedBy = (emailAddress) => {
            if (emailAddress) {
                const isValid = EMAIL_ADDRESS_REGULAR_EXPRESSION.test(emailAddress);
                return isValid;
            }

            return false;
        };

        self.isTrestaEmail = (emailAddress) => {
            if (emailAddress) {
                const emailDomain = emailAddress.split("@")[1].trim().toLowerCase();
                const isTrestaEmail = emailDomain === "patlive.com" || emailDomain === "tresta.com";
                return isTrestaEmail;
            }
            return false;
        };

        self.isEmailAddressAvailable = (emailAddress) => {
            return _promiseFactory.defer((promise) => {
                if (emailAddress === "") {
                    promise.resolve(true);
                } else {
                    const parameters = {
                        emailAddress: emailAddress.trim()
                    };
                    _webSocketApp.send("get_email_address_status", parameters, (result) => {
                        promise.resolve(result === "email_not_found");
                    });
                }
            });
        };
    };
});

